<template>
    <div class="form-group">
        <div class="position-relative">
            <fieldset
                :id="id"
                class="form-control cursor-default input-file pt-2"
                @click="$refs.file.click()"
            >
                <div
                    class="w-100"
                    style="overflow: hidden"
                >
                    <template v-if="value === null && name !== null && link !== null">
                        <a
                            :href="link"
                            target="_blank"
                            @click.stop
                        >
                            {{ name }}
                        </a>
                    </template>

                    <template v-else>
                        {{ value !== null ? value.name : name }}
                    </template>
                </div>
            </fieldset>

            <label
                :for="id"
                :class="{active: value !== null || name !== ''}"
                @click="$refs.file.click()"
            >
                <slot />
            </label>

            <i
                class="fas fa-paperclip select-arrow"
            />

            <input
                ref="file"
                type="file"
                class="d-none form-control-file"
                @change="$emit('input', $event.target.files[0])"
            >
        </div>

        <base-error :errors="errors" />
    </div>
</template>

<script>
    import BaseError from './BaseError'

    export default {
        name: 'BaseInputFile',

        components: { BaseError },

        props: {
            value: {type: Object, default: null},
            link: {type: String, default: null},
            name: {type: String, default: ''},
            errors: {type: Array, default: null}
        },

        data: function () {
            return {
                id: _.uniqueId()
            }
        },
    }
</script>
